import { render } from "./ModalAjuste.vue?vue&type=template&id=765bce93"
import script from "./ModalAjuste.vue?vue&type=script&lang=js"
export * from "./ModalAjuste.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__